export const PHI = (1 + Math.sqrt(5)) / 2
export const PHI_RATIO = 100 / PHI
export const ANTI_PHI_RATIO = 100 - PHI_RATIO

export const SQUARE = 1
export const PLACE_IMAGE_RATIO = 100 // 1:1
export const GROUP_IMAGE_RATIO = 200 // 2:1
export const THING_IMAGE_RATIO = 200 // 2:1
